import React from 'react';
import ReactTooltip from 'react-tooltip-lite';

import SvgTooltip from '@/icons/Tooltip';

import styles from './tooltip.module.scss';

export default function Tooltip({ children }) {
  return (
    <ReactTooltip
      tipContentClassName={styles.tip}
      effect='solid'
      content={children}
      itemScope
      itemType='http://schema.org/Property'
    >
      <span className={styles.block}>
        <SvgTooltip />
      </span>
    </ReactTooltip>
  );
}
